import { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useModulEnabled } from '../../../auth';
import { route } from '../config';

const GefahrgutDetails = lazy(() => import('./GefahrgutDetails'));
const GefahrgutLight = lazy(() => import('./GefahrgutLight'));
const GefahrgutListe = lazy(() => import('./GefahrgutListe'));

export default function GefahrgutRoute() {
  const gefahrgutEnabled = useModulEnabled('gefahrgut');
  return <Route path={route} component={gefahrgutEnabled ? GefahrgutNormal : GefahrgutLight} />;
}

function GefahrgutNormal() {
  return (
    <Switch>
      <Route exact path={route} component={GefahrgutListe} />
      <Route path={`${route}/:id`} component={GefahrgutDetails} />
    </Switch>
  );
}
